export enum EquipmentStatus {
    InActive = 0,
    Active = 1,
    OutForCalibrationOrRepair = 2,
}